import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { AllDevicesSettings } from "@/data/models/Settings";
import { createDefaultAllDevicesSettings } from "@/data/models/Client";

const name = "allDevicesSettings";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class AllDevicesSettingsVuexModule extends VuexModule {
  allDevicesSettings: AllDevicesSettings = createDefaultAllDevicesSettings();

  @Mutation
  setAllDevicesSettings(allDevicesSettings: AllDevicesSettings) {
    this.allDevicesSettings = allDevicesSettings;
  }

  @Mutation
  clear() {
    this.allDevicesSettings = createDefaultAllDevicesSettings();
  }
}

export const AllDevicesSettingsModule = getModule(AllDevicesSettingsVuexModule, store);
